import React, { createContext, useContext } from "react";

const TenantContext = createContext(null);

/**
 * Wrap route content in this once, at the /:tenant layout level, passing
 * the slug pulled from useParams(). Everything underneath can then call
 * useTenant() instead of re-reading useParams() itself.
 */
export const TenantProvider = ({ tenant, children }) => {
  return (
    <TenantContext.Provider value={tenant}>{children}</TenantContext.Provider>
  );
};

export const useTenant = () => {
  const tenant = useContext(TenantContext);
  if (!tenant) {
    // Not throwing here — some components (404 pages, tenant picker,
    // etc.) may legitimately render outside a resolved tenant.
    console.warn("useTenant() called with no tenant in context.");
  }
  return tenant;
};